function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.895,7.553l-2-4C18.725,3.214,18.379,3,18,3h-5c-0.379,0-0.725,0.214-0.895,0.553L10.382,7H6 C5.621,7,5.275,7.214,5.105,7.553l-2,4c-0.141,0.281-0.141,0.613,0,0.895l2,4C5.275,16.786,5.621,17,6,17h4.382l1.724,3.447 C12.275,20.786,12.621,21,13,21h5c0.379,0,0.725-0.214,0.895-0.553l2-4c0.141-0.281,0.141-0.613,0-0.895L19.118,12l1.776-3.553 C21.035,8.166,21.035,7.834,20.895,7.553z M13.618,5h3.764l1.5,3l-1.5,3h-3.764l-1.5-3L13.618,5z M5.118,12l1.5-3h3.764l1.5,3 l-1.5,3H6.618L5.118,12z M17.382,19h-3.764l-1.5-3l1.5-3h3.764l1.5,3L17.382,19z"
});

function SvgHiveSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    style: {
      fill: "rgba(0, 0, 0, 1)",
      transform: "",
      msFilter: ""
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiveSvg);
export default __webpack_public_path__ + "static/media/hiveSvg.bd92ab43.svg";
export { ForwardRef as ReactComponent };